import { CheckCircle2, ArrowRight } from "lucide-react";
import Reveal from "@/components/SectionReveal";

const POINTS = [
  "Reputable, vetted partnered contractors",
  "Turn-key install — equipment, plumbing, electrical, finish",
  "Premium pumps, filters, salt systems & heaters",
  "Energy-efficient, warranty-backed components",
  "Single point of contact from quote to dive-in day",
];

export default function PoolSystemsPromo() {
  return (
    <section className="relative py-24 sm:py-32 bg-slate-950 text-white overflow-hidden">
      {/* Decorative water curve */}
      <svg
        className="absolute inset-x-0 -top-px w-full text-white"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
      >
        <path
          d="M0 0 C 240 80 480 0 720 40 C 960 80 1200 0 1440 40 L 1440 0 Z"
          fill="currentColor"
        />
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal direction="left" className="lg:col-span-7">
          <p className="text-xs tracking-[0.22em] uppercase font-bold text-amber-400">
            Pool Systems in a Box
          </p>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Need a <span className="text-amber-300">NEW</span> Pool System?!
          </h2>
          <p className="mt-5 max-w-xl text-slate-300 text-lg">
            We&apos;ve got you covered. Our reputable partnered contractors handle full pool system installs and
            replacements — pumps, filters, salt cells, heaters, plumbing &amp; controls — bundled into one
            simple, turnkey package.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-slate-200">
                <CheckCircle2 className="w-5 h-5 text-amber-300 mt-0.5 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href="/contact"
              data-testid="pool-systems-cta"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-300 text-slate-900 font-bold hover:bg-amber-200 transition-colors"
            >
              Get my system quote
              <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="tel:+17276439404"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white font-semibold hover:bg-white/10 transition-colors"
              data-testid="pool-systems-call"
            >
              Talk to a pro
            </a>
          </div>
        </Reveal>

        <Reveal direction="right" delay={0.1} className="lg:col-span-5">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur shadow-2xl">
            <img
              src="https://images.pexels.com/photos/29702280/pexels-photo-29702280.jpeg"
              alt="Modern pool system equipment"
              className="w-full h-[420px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent" />
            <div className="absolute left-5 right-5 bottom-5">
              <p className="text-[11px] uppercase tracking-[0.22em] font-bold text-amber-300">
                Bundled · Warrantied · Installed
              </p>
              <p className="mt-1 font-heading text-2xl font-bold text-white">
                A complete pool system, ready in days.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
